// extracted by mini-css-extract-plugin
export default {"root":"ProductTrustMessage-root-3yr","stacked":"ProductTrustMessage-stacked-1Ew","label":"ProductTrustMessage-label-176"};